import { fetchWithAuth } from '../apiClient';

export async function fetchUserSettings(signal) {
  const res = await fetchWithAuth('/user-settings', { signal });
  return await res.json();
}

export async function fetchUserSettingsOptions(signal) {
  // Server must provide option lists — no client fallbacks allowed
  const res = await fetchWithAuth('/user-settings/options', { signal });
  return await res.json();
}

export async function updateUserSettings(partial) {
  // partial: { retryPolicy?, personality?, daytimePreference? }
  const res = await fetchWithAuth('/user-settings', { method: 'PUT', body: JSON.stringify(partial) });
  return await res.json();
}
